const Currency = {
  Peso: "peso",
  Liter: "liter",
  Points: "points",
};

export default Currency;
